import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useDecision } from '@optimizely/react-sdk'
import clsx from 'clsx'
import { paths } from 'src/router/paths'
import { ACCESS_TO_POST } from 'src/utils/constants'
import i18n from 'src/i18n'
import { NewsPostType } from 'src/hook/usePosts'
import Loading from '../Loading'
import { FeedCardProps, UrlPathParams } from './feedCard.types'
import { FeedCardBody, FeedCardFooter, FeedCardHeader, FeedCardLiveBar } from './components'
import { LoadingWrapper, Wrapper } from './feedCard.styles'

const FeedCard = ({
  post,
  highlight,
  enableCommentInput,
  isScheduledPost,
  isProcessingVideo,
  className
}: FeedCardProps) => {
  const navigate = useNavigate()
  const { lang, membership } = useParams<UrlPathParams>()
  const [commentMentionFeatureFlag] = useDecision('com_eng_web_enable_comment_mention')

  const postBasePath = generatePath(paths.COMMUNITY_POST_PATH, {
    lang,
    membership,
    idCommunity: String(post?.ownerCollectionId),
    idPost: String(post?.id)
  })

  const postPath = `${postBasePath}?origin=${ACCESS_TO_POST.COMMUNITY_POST_FEED}&postId=${post.id}`
  const isLivePost = post.postType === NewsPostType.LIVE

  const handleClickComments = () => navigate(postPath)

  return (
    <Wrapper
      className={clsx(className, '_bg-gray-100 _rounded-lg _position-relative')}
      $highlight={highlight}
    >
      {isProcessingVideo && (
        <LoadingWrapper className="_position-absolute _d-flex _justify-content-center _align-items-center">
          <Loading text={i18n.t('input_publish.loading_video_progress')} />
        </LoadingWrapper>
      )}

      <FeedCardHeader post={post} isScheduledPost={isScheduledPost} />

      {isLivePost && <FeedCardLiveBar post={post} />}

      <FeedCardBody post={post} postPath={postPath} isProcessingVideo={isProcessingVideo} />

      <FeedCardFooter
        post={post}
        enableCommentSuggestion={commentMentionFeatureFlag?.enabled}
        enableMentions
        enableCommentInput={enableCommentInput && !highlight}
        onClickCommentCounter={handleClickComments}
      />
    </Wrapper>
  )
}

export default FeedCard
